<template>
  <div class="step-indicator-simple" :style="{ width: width }">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :class="{ current: current == step.step, valid: step.visited && step.valid }"
      @click="goToStep(step)"
      :tooltip="tooltipText"
      @mouseover="setTooltipText(step.title)"
      tooltip-placement="bottom"
    >
      <div class="step-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    current: Number,
    disabled: Boolean,
    width: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      tooltipText: null
    };
  },
  methods: {
    goToStep(step) {
      if (step.step == this.current || step.disabled == true || this.disabled == true) {
        return;
      }
      if (!step.allowed) {
        this.setTooltipText(step.deniedAccessMsg);
        return;
      }
      this.$emit("click-step", step.step);
    },
    setTooltipText(text) {
      this.tooltipText = text;
    }
  },
  watch: {
    current: {
      handler: function() {
        this.steps.find((s) => s.step == this.current).visited = true;
      }
    }
  }
};
</script>

<style lang="less">
:root {
  --inactive-size: 2px;
  --active-size: 2px;
}
.step-indicator-simple {
  margin: 0 auto;
  display: flex;
  gap: 2px;
  flex-direction: row;
  align-items: flex-end;
  .step {
    cursor: pointer;
    padding: 8px 0;
    flex: 1 1 auto;
    .step-line {
      height: var(--inactive-size);
      // width: 100%;
      border-radius: 4px;
      background-color: var(--charcoal-20);
    }
    &.current,
    &.current.valid {
      .step-line {
        height: var(--active-size);
        background-color: var(--orange-web);
      }
      &:hover > .step-line {
        background-color: var(--orange-web);
        filter: brightness(120%);
      }
    }
    &.valid .step-line {
      height: var(--inactive-size);
      background-color: var(--orange-web-40);
    }
    &:not(.current).valid:hover > .step-line {
      background-color: var(--orange-web);
    }
    &:not(.current, .valid):hover > .step-line {
      background-color: var(--charcoal-50);
    }
  }
}
.first-enter-to .last-enter-to {
  position: absolute;
  opacity: 1;
  transform: translateX(0);
}
.first-enter,
.first-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-100px);
}

.last-enter,
.last-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(100px);
}
.first-enter-active,
.first-leave-active {
  transition: all 0.2s ease;
}
.last-leave-active,
.last-enter-active {
  transition: all 0.2s ease;
  // transition-delay: 0.1s;
}

.mid-next-enter {
  position: absolute;
  opacity: 0;
  transform: translateX(100px);
}
.mid-next-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-100px);
}
.mid-next-leave-active,
.mid-next-enter-active {
  transition: all 0.2s ease;
  // transition-delay: 0.1s;
}

.mid-previous-enter {
  position: absolute;
  opacity: 0;
  transform: translateX(-100px);
}
.mid-previous-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(100px);
}
.mid-previous-leave-active,
.mid-previous-enter-active {
  transition: all 0.2s ease;
  // transition-delay: 0.1s;
}
</style>
